import React from 'react';
import { InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';

import * as S from './styles';

interface InfoBoxProps {
	title: string;
	type: 'info' | 'warning' | 'danger';
}

export function InfoBox({ title, type }: InfoBoxProps): JSX.Element {
	return (
		<S.ContainerInfoBox type={type}>
			<>
				{type === 'info' || type === 'danger' ? <InfoCircleOutlined /> : <WarningOutlined />} {title}
			</>
		</S.ContainerInfoBox>
	);
}
